import { ActionTree } from 'vuex'

import { MonitorState, RootState } from '@/types/store'

import { getMonitors } from '@/api/monitors'

import { IMonitor } from '@/types/monitor'

export const actions: ActionTree<MonitorState, RootState> = {
  async getMonitors({ commit }, data?: any): Promise<void> {
    const { lastId, ...query } = data
    commit('monitorsLoaded', [])
    commit('monitorsLoadStart', true)
    const multiusers = await getMonitors(lastId, query)
    commit('monitorsLoaded', multiusers)
  },
  async getMonitor({ commit }, monitor: IMonitor): Promise<void> {
    commit('setMonitor', monitor)
  },
}
